module.exports = __webpack_public_path__ + "img/6.b2b5b6c0.svg";